// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Document */


/***************** html tag ******************/
body[data-page-id="loginView"] {
	padding: 0;
}

a, 
a:hover {
	color: hsl(182, 100%, 40%);
}

a:hover {
	text-decoration: none;
}

/******************** site colors *******************/

/******************** site *******************/
h2 {
	color: hsl(0, 0%, 100%);
	margin-bottom: .5em;
}

.form-box {
	align-items: center;
	background: hsl(0, 0%, 100%);
	display: flex;
	height: 100%;
	isolation: isolate;
	justify-content: center;
	left: 0;
	overflow: hidden;
	position: absolute;
	top: 0px;
	transition: .5s ease-in-out;
	width: 100%;
}

.form-box form {
	left: 0;
	padding: 0 10%;
	position: absolute;
	transition: .5s;
	width: 100%;
}

.form-box .signinForm {
	transition-delay: .25s;
}

.form-box .signupForm {
	left: 100%;
	transition-delay: 0s;
}

.form-switch label {
	vertical-align: -4px;
}

.sign-box {
	isolation: isolate;
	height: 150px;
}

.sign-container {
	position: relative;
}

.sign-container > * {
	height: 360px;
}

.sign-container .row [class^="col-"] {
	background: hsla(0, 0%, 100%, .2);
	box-shadow: 0 5px 45px hsla(0, 0%, 0%, .15);
}

.sign-view {
	align-items: center;
	background: hsl(198, 80%, 45%);
	height: 100%;
	min-height: 100vh;
	/* padding-top: 5em; */
	text-align: center;
	transition: .5s;
}

.sign-view .signup {
	margin-top: 210px;
}

.sign-view.up-active {
	background: hsl(268, 80%, 45%);
}

.sign-view.up-active .form-box {
	left: 0;
	top: 150px;
}

.sign-view.up-active .form-box .signinForm {
	left: -100%;
	transition-delay: 0s;
}

.sign-view.up-active .form-box .signupForm {
	left: 0;
	transition-delay: .25s;
}

.sign-view.up-active .signup {
	margin-top: 0;
}

#signViewLogo {
	color: hsl(0, 0%, 100%);
	font-size: 3.75em;
	line-height: 1em;
	margin-bottom: .5em;
	margin-top: .5em;
	text-align: center;
}

/******************** mediaQuery *******************/
@media (max-width: 991.98px) and (orientation: landscape) {
	.sign-view {
		min-height: 100vw;
	}
}

@media (min-width: 992px) {
	.form-box {
		box-shadow: 0 5px 45px hsla(0, 0%, 0%, .25);
		top: 0;
		width: 50%;
	}

	.form-box form {
		padding: 0 25%;
	}
	
	.sign-container > * {
		height: 500px;
	}

	.sign-container .row {
		align-items: center!important;
	}

	.sign-container .row [class^="col-"] {
		height: 420px;
	}

	.sign-view {
		display: flex;
		justify-content: center;
		min-height: 100vh;
	}

	.sign-view.up-active .form-box {
		left: 50%;
		top: 0;
	}

	.sign-view .sign-box, 
	.sign-view.up-active .sign-box {
		margin-top: 150px;
	}
	
	#signViewLogo {
		margin-bottom: 1.5em;
		margin-top: 0;
	}
}
`, "",{"version":3,"sources":["webpack://./src/views/login/style.css"],"names":[],"mappings":"AAAA,iBAAiB;;;AAGjB,8CAA8C;AAC9C;CACC,UAAU;AACX;;AAEA;;CAEC,0BAA0B;AAC3B;;AAEA;CACC,qBAAqB;AACtB;;AAEA,qDAAqD;;AAErD,8CAA8C;AAC9C;CACC,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,4BAA4B;CAC5B,aAAa;CACb,YAAY;CACZ,kBAAkB;CAClB,uBAAuB;CACvB,OAAO;CACP,gBAAgB;CAChB,kBAAkB;CAClB,QAAQ;CACR,2BAA2B;CAC3B,WAAW;AACZ;;AAEA;CACC,OAAO;CACP,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,UAAU;CACV,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,iCAAiC;CACjC,2CAA2C;AAC5C;;AAEA;CACC,mBAAmB;CACnB,8BAA8B;CAC9B,YAAY;CACZ,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,OAAO;CACP,UAAU;AACX;;AAEA;CACC,WAAW;CACX,oBAAoB;AACrB;;AAEA;CACC,OAAO;CACP,sBAAsB;AACvB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,uBAAuB;CACvB,iBAAiB;CACjB,gBAAgB;CAChB,mBAAmB;CACnB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA,oDAAoD;AACpD;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,2CAA2C;EAC3C,MAAM;EACN,UAAU;CACX;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,6BAA6B;CAC9B;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;EACb,uBAAuB;EACvB,iBAAiB;CAClB;;CAEA;EACC,SAAS;EACT,MAAM;CACP;;CAEA;;EAEC,iBAAiB;CAClB;;CAEA;EACC,oBAAoB;EACpB,aAAa;CACd;AACD","sourcesContent":["/* CSS Document */\r\n\r\n\r\n/***************** html tag ******************/\r\nbody[data-page-id=\"loginView\"] {\r\n\tpadding: 0;\r\n}\r\n\r\na, \r\na:hover {\r\n\tcolor: hsl(182, 100%, 40%);\r\n}\r\n\r\na:hover {\r\n\ttext-decoration: none;\r\n}\r\n\r\n/******************** site colors *******************/\r\n\r\n/******************** site *******************/\r\nh2 {\r\n\tcolor: hsl(0, 0%, 100%);\r\n\tmargin-bottom: .5em;\r\n}\r\n\r\n.form-box {\r\n\talign-items: center;\r\n\tbackground: hsl(0, 0%, 100%);\r\n\tdisplay: flex;\r\n\theight: 100%;\r\n\tisolation: isolate;\r\n\tjustify-content: center;\r\n\tleft: 0;\r\n\toverflow: hidden;\r\n\tposition: absolute;\r\n\ttop: 0px;\r\n\ttransition: .5s ease-in-out;\r\n\twidth: 100%;\r\n}\r\n\r\n.form-box form {\r\n\tleft: 0;\r\n\tpadding: 0 10%;\r\n\tposition: absolute;\r\n\ttransition: .5s;\r\n\twidth: 100%;\r\n}\r\n\r\n.form-box .signinForm {\r\n\ttransition-delay: .25s;\r\n}\r\n\r\n.form-box .signupForm {\r\n\tleft: 100%;\r\n\ttransition-delay: 0s;\r\n}\r\n\r\n.form-switch label {\r\n\tvertical-align: -4px;\r\n}\r\n\r\n.sign-box {\r\n\tisolation: isolate;\r\n\theight: 150px;\r\n}\r\n\r\n.sign-container {\r\n\tposition: relative;\r\n}\r\n\r\n.sign-container > * {\r\n\theight: 360px;\r\n}\r\n\r\n.sign-container .row [class^=\"col-\"] {\r\n\tbackground: hsla(0, 0%, 100%, .2);\r\n\tbox-shadow: 0 5px 45px hsla(0, 0%, 0%, .15);\r\n}\r\n\r\n.sign-view {\r\n\talign-items: center;\r\n\tbackground: hsl(198, 80%, 45%);\r\n\theight: 100%;\r\n\tmin-height: 100vh;\r\n\t/* padding-top: 5em; */\r\n\ttext-align: center;\r\n\ttransition: .5s;\r\n}\r\n\r\n.sign-view .signup {\r\n\tmargin-top: 210px;\r\n}\r\n\r\n.sign-view.up-active {\r\n\tbackground: hsl(268, 80%, 45%);\r\n}\r\n\r\n.sign-view.up-active .form-box {\r\n\tleft: 0;\r\n\ttop: 150px;\r\n}\r\n\r\n.sign-view.up-active .form-box .signinForm {\r\n\tleft: -100%;\r\n\ttransition-delay: 0s;\r\n}\r\n\r\n.sign-view.up-active .form-box .signupForm {\r\n\tleft: 0;\r\n\ttransition-delay: .25s;\r\n}\r\n\r\n.sign-view.up-active .signup {\r\n\tmargin-top: 0;\r\n}\r\n\r\n#signViewLogo {\r\n\tcolor: hsl(0, 0%, 100%);\r\n\tfont-size: 3.75em;\r\n\tline-height: 1em;\r\n\tmargin-bottom: .5em;\r\n\tmargin-top: .5em;\r\n\ttext-align: center;\r\n}\r\n\r\n/******************** mediaQuery *******************/\r\n@media (max-width: 991.98px) and (orientation: landscape) {\r\n\t.sign-view {\r\n\t\tmin-height: 100vw;\r\n\t}\r\n}\r\n\r\n@media (min-width: 992px) {\r\n\t.form-box {\r\n\t\tbox-shadow: 0 5px 45px hsla(0, 0%, 0%, .25);\r\n\t\ttop: 0;\r\n\t\twidth: 50%;\r\n\t}\r\n\r\n\t.form-box form {\r\n\t\tpadding: 0 25%;\r\n\t}\r\n\t\r\n\t.sign-container > * {\r\n\t\theight: 500px;\r\n\t}\r\n\r\n\t.sign-container .row {\r\n\t\talign-items: center!important;\r\n\t}\r\n\r\n\t.sign-container .row [class^=\"col-\"] {\r\n\t\theight: 420px;\r\n\t}\r\n\r\n\t.sign-view {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: center;\r\n\t\tmin-height: 100vh;\r\n\t}\r\n\r\n\t.sign-view.up-active .form-box {\r\n\t\tleft: 50%;\r\n\t\ttop: 0;\r\n\t}\r\n\r\n\t.sign-view .sign-box, \r\n\t.sign-view.up-active .sign-box {\r\n\t\tmargin-top: 150px;\r\n\t}\r\n\t\r\n\t#signViewLogo {\r\n\t\tmargin-bottom: 1.5em;\r\n\t\tmargin-top: 0;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
